import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { clsx } from "./auth-service-tools193.js";
import { Box } from "./auth-service-tools244.js";
import { useModalBaseContext } from "./auth-service-tools286.js";
import classes from "./auth-service-tools290.js";
const ModalBaseHeader = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    ...others
  } = _ref;
  const ctx = useModalBaseContext();
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    component: "header",
    ref,
    className: clsx({
      [classes.header]: !ctx.unstyled
    }, className),
    ...others
  });
});
ModalBaseHeader.displayName = "@mantine/core/ModalBaseHeader";
export { ModalBaseHeader };